
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/common/Logo";

export default function PrivacyTerms() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b">
        <div className="container flex h-16 items-center justify-between">
          <Logo size="medium" />
          <Button onClick={() => navigate("/")}>Back to Home</Button>
        </div>
      </header>

      <main className="flex-1 container py-12 max-w-3xl">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy & Terms of Service</h1>
        <div className="text-sm text-muted-foreground mb-4">
          Effective Date: March 19, 2025 | Last Updated: March 19, 2025
        </div>
        
        <div className="prose prose-slate max-w-none">
          <p>
            By using Hour Tracker, you agree to the following Privacy Policy and Terms of Service. 
            We collect user data, including account details (name, email), billing information (work logs, invoices), 
            and usage data (IP address, device info) to provide and improve our Service, generate invoices, 
            and comply with legal obligations.
          </p>
          
          <p>
            We do not sell or rent user data but may share it with service providers (e.g., hosting, payment processing) 
            or legal authorities when required. While we take reasonable steps to protect user data, security cannot be 
            fully guaranteed, and users assume responsibility for their information.
          </p>
          
          <p>
            Users are solely responsible for the accuracy of their invoices, compliance with tax and accounting laws, 
            and any disputes with clients. Hour Tracker is provided "as is" without warranties, and we are not liable 
            for unpaid invoices, data loss, lost income, or any damages.
          </p>
          
          <p>
            Our total liability is limited to the amount paid for the Service in the past 12 months (if any). 
            Users agree to indemnify and hold us harmless from legal claims arising from their use of the Service.
          </p>
          
          <p>
            These Terms are governed by the laws of New Jersey, and any disputes must be resolved through binding 
            arbitration in New Jersey. We reserve the right to modify these Terms at any time, and continued use of 
            the Service constitutes acceptance of the changes.
          </p>
        </div>
      </main>

      <footer className="border-t py-8">
        <div className="container text-center text-sm text-muted-foreground">
          <p>© {currentYear} Hour Tracker. All rights reserved.</p>
          <div className="flex justify-center gap-4 mt-2">
            <a href="#" onClick={(e) => {e.preventDefault(); navigate("/privacy-terms")}} className="hover:underline">
              Privacy Policy & Terms of Service
            </a>
            <a href="#" className="hover:underline">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
